import 'bootstrap';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import JustValidate from 'just-validate';
import flatpickr from "flatpickr";
import { Italian } from "flatpickr/dist/l10n/it.js"
import L from 'leaflet';


import { createApp } from 'vue'

// import VUE components
import Example from './vue-components/example.vue';
// Supports weights 300-800
import '@fontsource/open-sans/';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/jost/';
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";
import "@fontsource/jost/700.css";
import "@fontsource/jost/800.css";
import "@fontsource/jost/900.css";
import "@fontsource/josefin-sans";
import "@fontsource/josefin-sans/600.css";
import "flatpickr/dist/flatpickr.min.css";
import 'leaflet/dist/leaflet.css';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

(function ($) {

    var $ = require('jquery');
    window.jQuery = window.$ = $;
    require("./scss/main.scss");
    require('datatables.net');
    require('datatables.net-dt');
    require('leaflet');
    require('corejs-typeahead');
    require('typeahead-address-photon');
    require('flatpickr');
    window.Splide = Splide;
    window.JustValidate = JustValidate;
    window.Italian = Italian;
    require('./components/megamenu/altramamenu');


    //init MULTI SELECT
    const selectFilter = document.querySelectorAll('select.search-filter');
    const filtriAttivi = document.querySelector('.active-filter-container');
    const labelFiltriAttivi = document.querySelector('.active-filter-elements');
    selectFilter.forEach(select => {
        let selectItems = [];
        let placeholder = select.querySelector(('option[value="-1"]'));
        let placeholderLabel = placeholder.textContent;
        select.addEventListener('change', function () {
            const selectValue = this.value;
            if (selectValue != -1) {
                const index = selectItems.indexOf(selectValue);
                select.querySelector(('option[value="' + selectValue + '"]')).hidden = true;
                let filtername = select.querySelector(('option[value="' + selectValue + '"]')).textContent;
                if (index === -1) {
                    selectItems.push(selectValue);

                    // Crea il div "toast-filter"
                    const toastDiv = document.createElement('div');
                    toastDiv.className = 'toast-filter';
                    toastDiv.setAttribute('target', select.id);  // select.id è quello che già usi

                    // Crea lo span con il nome del filtro
                    const spanLabel = document.createElement('span');
                    spanLabel.className = 'toast-label';
                    spanLabel.textContent = filtername;  // filtername è quello che già usi

                    // Crea lo span "close" con SVG
                    const spanClose = document.createElement('span');
                    spanClose.className = 'toast-close m-auto me-2';
                    spanClose.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 12L12 4M4 4L12 12" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';

                    // 🔸 Aggiungi l'event listener al pulsante chiusura
                    spanClose.addEventListener('click', function () {
                        toastDiv.remove();  // Rimuove l'intero "toast-filter"
                        // 1️⃣ Seleziona il select nativo
                        const selectElement = document.getElementById(select.id);
                        // 2️⃣ Imposta il valore (nativamente)
                        selectElement.value = selectValue;
                        // 3️⃣ Lancia l'evento change nativo
                        const event = new Event('change', { bubbles: true });
                        selectElement.dispatchEvent(event);
                        select.querySelector(('option[value="' + selectValue + '"]')).hidden = false;
                        if (labelFiltriAttivi.children.length == 0) {
                            $(filtriAttivi).addClass('d-none');
                        }
                    });

                    // 🔸 Componi l'elemento
                    toastDiv.appendChild(spanLabel);
                    toastDiv.appendChild(spanClose);
                    // 🔸 Aggiungi al contenitore
                    labelFiltriAttivi.appendChild(toastDiv);
                    $(filtriAttivi).removeClass('d-none');
                }
                else {
                    selectItems.splice(index, 1);
                }

                if (selectItems.length == 1) {
                    placeholder.textContent = selectItems.length + " elemento selezionato";
                }
                else if (selectItems.length > 1) {
                    placeholder.textContent = selectItems.length + " elementi selezionati";
                }
                else {
                    placeholder.textContent = placeholderLabel;
                }
                $(this).val(-1).change();

            }
            $(this).attr('multi-value', selectItems);
        });
    });

    let render_component = function (component, id, data) {
        createApp(component, data).mount(id);
    }

    ///// VUE DEFAULT SHORTCODES START

    ///// ##0 EXAMPLE
    window.render_example = function (id, dataValue) {
        return render_component(Example, id, dataValue);
    }
    ///// VUE DEFAULT SHORTCODES END

    //INIT VISTa
    $('body').attr("style", "");

    $('#btn-global-search').on("click", (e) => {
        e.preventDefault();
        $('#cerca>a:not(.toggle)').click();
        $('#cerca-2>a:not(.toggle)').click();
    });

    $('.close-menu').on("click", (e) => {
        e.preventDefault();
        console.log($(e.currentTarget).attr('menu-close'));
        $('#' + $(e.currentTarget).attr('menu-close') + '>a:not(.toggle)').click();
    });



    window.cardAppend = function () {
        $('.card-wrapper a').off("click").on("click", (e) => {
            if (e.target.classList.contains('favorite-label') || e.target.classList.contains('favorite') || e.target.classList.contains('favorite-icon') || e.target.classList.contains('favorite-heart')) {
                let id;
                e.preventDefault();
                //debugger;
                if (e.target.tagName.toUpperCase() === 'SVG') {
                    //e.target.classList.toggle('is-favorite');
                    id = e.target.getAttribute('post-id');
                    //toggleLS(e.target.getAttribute('post-id'));
                }
                else if (e.target.tagName.toUpperCase() === 'DIV') {
                    //e.target.querySelector('svg').classList.toggle('is-favorite');
                    id = e.target.querySelector('svg').getAttribute('post-id');
                    //toggleLS(e.target.querySelector('svg').getAttribute('post-id'));
                }
                else if (e.target.tagName.toUpperCase() === 'SPAN') {
                    //e.target.parentElement.querySelector('svg.favorite-icon').classList.toggle('is-favorite');
                    id = e.target.parentElement.querySelector('svg.favorite-icon').getAttribute('post-id');
                }
                else {
                    //e.target.parentElement.classList.toggle('is-favorite');
                    id = e.target.parentElement.getAttribute('post-id');
                    //toggleLS(e.target.parentElement.getAttribute('post-id'));
                }
                toggleLS(id);
                document.querySelectorAll('[post-id="' + id + '"]').forEach(element => {
                    element.classList.toggle('is-favorite');
                });

            }
        });
    }

    cardAppend();

    function toggleLS(id) {
        let favorites = localStorage.getItem('favorites');
        if (favorites == null) {
            favorites = new Array();
        }
        else {
            favorites = JSON.parse(favorites)
        }
        addOrRemove(favorites, id);
        localStorage.setItem('favorites', JSON.stringify(favorites));
        function addOrRemove(array, value) {
            var index = array.indexOf(value);
            if (index === -1) {
                array.push(value);
            } else {
                array.splice(index, 1);
            }
        }

    }

    window.loadFavorites = function () {
        let favorites = localStorage.getItem('favorites');
        if (favorites == null) {
            favorites = new Array();
        }
        else {
            favorites = JSON.parse(favorites)
            favorites.forEach(e => {
                try {
                    document.querySelectorAll('[post-id="' + e + '"]').forEach(element => {
                        element.classList.add('is-favorite');
                    });
                } catch (error) {
                    console.log("Nessuno dei preferiti è presente nella pagina");
                }
            });
        }
    }

    loadFavorites();

    function addFavoriteDate(id, time) {
        // Recupera l'array esistente, o inizializza vuoto
        const favorites = JSON.parse(localStorage.getItem('favoritesDates')) || [];

        // Rimuove eventuali duplicati per lo stesso id
        const filtered = favorites.filter(item => item.id !== id);

        // Aggiunge il nuovo oggetto
        filtered.push({ id, time });

        // Salva di nuovo nel localStorage
        localStorage.setItem('favoritesDates', JSON.stringify(filtered));
    }


    //SPLIDE
    try {
        var splide = new Splide('.splide')
        splide.on('mounted move', function (newIndex) {
            updateCaption(newIndex);
            const slideCount = splide.length; // Numero di slide

            if (slideCount <= 1) {
                splide.options = { arrows: false };  // Disabilita le frecce
            }
        });
        splide.mount();
        function updateCaption(index) {
            if (index == undefined) {
                index = 0;
            }
            var slide = splide.Components.Slides.getAt(index).slide;
            var caption = slide.getAttribute('data-caption');
            let captionBox = document.getElementById('image-copyright');
            try {
                captionBox.textContent = ('© ' + caption) || '';
            }
            catch (e) {

            }
        }
    }
    catch (e) {
        console.log('No Carousel');
    }

    //JUST VALIDATE
    try {
        window.validator = new JustValidate('.justvalidate');
    }
    catch (e) {
        console.log('No Form');
    }


    window.loadInstagram = (e) => {
        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'instagram_callback', // Nome dell'azione registrata in PHP
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                e.html("");
                response.data.forEach(element => {
                    if (element.media_type == "IMAGE" || element.media_type == "CAROUSEL_ALBUM") {
                        e.append(instagram_card(element.media_url, element.permalink, element.caption));
                    }
                    else if (element.media_type == "VIDEO") {
                        e.append(instagram_card(element.media_url, element.permalink, element.caption, 'video'));
                    }
                });


            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
        e.show();
    }

    function instagram_card(thumb_url, url, caption, type = 'div') {
        var newCardHTML =
            '<div class="card-wrapper card-4-wrapper col-6 col-md-3"><a style="position:relative" target="_blank" href="' + url + '"title="' + caption + '"><' + type + ' autoplay muted loop playsinline src="' + thumb_url + '"class="card-4" style="background-image:url(' + thumb_url + '"><div class="card-mask-2"></div><div class="card-title-wrapper"></div></' + type + '><img src="data:image/svg+xml;base64,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" alt="" style="width: 20px;height: 20px;position: absolute;bottom: 10px;left: 10px;"></a></div>';
        return newCardHTML;
    }

    window.subscribe = (email, e) => {
        const subok = '<div class="sub-ok" style="color: green;background: white;">Iscrizione avvenuta con successo ✔</div>'
        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'register_newsletters_callback', // Nome dell'azione registrata in PHP
                email: email
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                $('#email').val('');
                $('#trattamento').prop('checked', false);
                e.append(subok);
                console.log('Iscritto!');
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }

    window.filterControl = () => {
        const filterWrapper = document.querySelector(".filter-wrapper");
        const filters = document.querySelectorAll('.hide-mobile-filter');
        if (filterWrapper) {
            filterWrapper.addEventListener("click", function () {
                this.classList.toggle("filter-expanded");
                filters.forEach(element => {
                    element.classList.toggle("opacity-0");
                    element.classList.toggle("invisible-0");
                    element.classList.toggle("h-0");
                });

            });
        }
    }

    window.searchArchive = (searchbar, container, paginator, loader, page) => {

        const searchbtn = searchbar.querySelector('#search-submit');

        search(searchbar, container, paginator, loader, page, true);

        searchbar.addEventListener('submit', function (e) {
            e.preventDefault();
            search(searchbar, container, paginator, loader, page);
        });

        try {
            searchbtn.addEventListener('click', function (e) {
                e.preventDefault();
                search(searchbar, container, paginator, loader, page);
            });
        } catch (error) {

        }


        //e.show();        
    }

    function search(searchbar, container, paginator, loader, page, first = false) {

        if (searchbar) {
            let text = searchbar.querySelector('[name=s]')?.value ?? '';

            let postType = searchbar.querySelector('[name=post-type]').value;

            let dateFrom = searchbar.querySelector('[name=date-from]')?.value ?? -1;

            let dateTo = searchbar.querySelector('[name=date-to]')?.value ?? -1;

            let postId = searchbar.querySelector('[name=post-id]')?.value ?? -1;
            const filters = [];
            searchbar.querySelectorAll('.search-filter').forEach(filter => {
                filters.push({ id: filter.id, value: $(filter).attr('multi-value') });
            });
            let favorites = [];
            let favoritesDates = [];
            if (postType == 'il-mio-viaggio-in-molise' || postType == 'my-trip-to-molise') {
                favorites = localStorage.getItem('favorites');
                favoritesDates = localStorage.getItem('favoritesDates');
            }
            $.ajax({
                url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
                type: 'POST', // Tipo di richiesta
                dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
                data: {
                    action: 'archive_search_callback', // Nome dell'azione registrata in PHP
                    first: first,
                    page: page,
                    text: text,
                    postType: postType,
                    postId: postId,
                    date: [dateFrom, dateTo],
                    filter: filters,
                    favorites: favorites,
                    favoritesDates: favoritesDates
                },
                beforeSend: function () {
                    container.addClass('opacity-0');
                    loader.removeClass('opacity-0');
                },
                success: function (response) {
                    // Gestione della risposta in caso di successo
                    if (response.html) {
                        container.html("");
                        container.append(response.html);
                        container.removeClass('opacity-0');
                        loader.addClass('opacity-0');
                        cardAppend();
                        loadFavorites();
                    }
                    else {
                        if (postType == 'il-mio-viaggio-in-molise' || postType == 'my-trip-to-molise') {
                            container.parent().parent().parent().parent().parent().remove();
                        }
                    }

                    if (response.paginator) {
                        paginator.html("");
                        paginator.append(response.paginator);

                        paginator[0].querySelectorAll('a.page-link:not(.disabled)').forEach(link => {
                            link.addEventListener('click', function (e) {
                                e.preventDefault(); // blocca il comportamento di default se serve
                                search(searchbar, container, paginator, loader, e.target.getAttribute('page'));
                                // ... qui puoi fare la tua logica di cambio pagina
                            }, { once: true });
                        });

                    }

                    if (response.resource) {
                        Object.entries(response.resource).forEach(element => {
                            const select = document.getElementById(element[0]);
                            if (Array.isArray(element[1])) {
                                element[1].forEach(o => {
                                    const option = document.createElement('option');
                                    option.value = o.term_id;
                                    option.textContent = new DOMParser().parseFromString(o.name, 'text/html').body.textContent;
                                    select.appendChild(option);
                                })
                            }
                        });
                        if (first) {
                            const params = new URLSearchParams(window.location.search);
                            const tipo = params.get('tipo');
                            const tipologia = params.get('tipologia');
                            const destinazioni = params.get('destinazioni');
                            const passioni = params.get('passioni');
                            if (postType == "dove-mangiare" && tipo != null && tipo != '') {
                                const selectElement = document.getElementById('tag-tipologia-di-dove-mangiare');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipo;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "dove-mangiare" && destinazioni != null && destinazioni != '') {
                                const selectElement = document.getElementById('destinazione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = destinazioni;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "dove-dormire" && tipo != null && tipo != '') {
                                const selectElement = document.getElementById('tag-tipologia-di-dove-dormire');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipo;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "dove-dormire" && destinazioni != null && destinazioni != '') {
                                const selectElement = document.getElementById('destinazione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = destinazioni;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "punto-di-interesse" && tipologia != null && tipologia != '') {
                                const selectElement = document.getElementById('tag-tipologia-punto-di-interes');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipologia;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "punto-di-interesse" && destinazioni != null && destinazioni != '') {
                                const selectElement = document.getElementById('destinazione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = destinazioni;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }                            
                            if (postType == "evento" && tipo != null && tipo != '') {
                                const selectElement = document.getElementById('tag-tipologia-di-evento');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipo;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "evento" && destinazioni != null && destinazioni != '') {
                                const selectElement = document.getElementById('destinazione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = destinazioni;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }                            
                            if (postType == "azienda" && tipo != null && tipo != '') {
                                const selectElement = document.getElementById('tag-tipologia-di-aziende');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipo;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if (postType == "destinazioni" && tipo != null && tipo != '') {
                                const selectElement = document.getElementById('tipologia_destinazione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = tipo;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                            if ((postType == "idee-di-viaggio" || postType == "itinerario" || postType == "esperienza") && passioni != null && passioni != '') {
                                const selectElement = document.getElementById('passione');
                                // 2️⃣ Imposta il valore (nativamente)
                                selectElement.value = passioni;
                                // 3️⃣ Lancia l'evento change nativo
                                const event = new Event('change', { bubbles: true });
                                selectElement.dispatchEvent(event);
                            }
                        }
                    }

                    if (response.marker) {
                        if (Array.isArray(response.marker)) {
                            loadSearchMarker(response.marker);
                        }
                        else {
                            loadSearchMarker();
                        }
                    }
                    else {
                        loadSearchMarker();
                    }

                    if (postType == 'il-mio-viaggio-in-molise' || postType == 'my-trip-to-molise') {

                        $('.modifiy-date').off("click").on("click", (e) => {
                            if (e.target.classList.contains('modify-date-label') || e.target.classList.contains('button-primary') || e.target.classList.contains('button-primary-i') || e.target.classList.contains('button-primary-ii')) {
                                e.preventDefault();
                                if (e.target.classList.contains('modify-date-label')) {
                                    const btnassegna = e.currentTarget.querySelector('.button-primary-ii');
                                    const input = e.currentTarget.querySelector('input[name="data"]');
                                    const c = flatpickr(input, {
                                        locale: Italian,
                                        dateFormat: "d m y",  // Imposta il formato della data
                                        minDate: "today",  // Data minima
                                        onChange: function (selectedDates) {
                                            try {
                                                btnassegna.innerHTML = formatDateLong(selectedDates[0]);
                                                addFavoriteDate(input.getAttribute('favorite-id'), getUnixSeconds(selectedDates[0]));
                                                console.log(getUnixSeconds(selectedDates[0]));
                                            }
                                            catch (error) {

                                            }
                                        }
                                    });
                                    c.open();
                                }

                            }

                        });
                    }
                },
                error: function (xhr, status, error) {
                    // Gestione degli errori
                    console.error('Errore nella richiesta:', error);

                }
            });
        }
    }
    window.formatDate = function (date) {
        return date.toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
        });
    }
    window.formatDateLong = function (date) {
        return date.toLocaleDateString('it-IT', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    }
    window.getUnixSeconds = function (date) {
        return Math.floor(date.getTime() / 1000);
    };

    window.loadSearchMarker = function (locations) {

        const mapContainer = document.getElementById('search-map');
        // Controlla se esiste già una mappa Leaflet su questo elemento
        if (mapContainer._leaflet_id) {
            // Dalla doc interna di Leaflet: distruggere una mappa esistente
            console.log(mapContainer._leaflet_id);
            mapContainer.leafletInstance.remove();

        }
        // Centra la mappa sul Molise (Campobasso come riferimento)
        const map = L.map('search-map').setView([41.5606, 14.6628], 9);
        mapContainer.leafletInstance = map;
        const customIcon = L.icon({
            iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMxRDVFNjgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4wNTAzIDkuMDUwMjVDMTIuNzgzOSA2LjMxNjU4IDE3LjIxNjEgNi4zMTY1OCAxOS45NDk3IDkuMDUwMjVDMjIuNjgzNCAxMS43ODM5IDIyLjY4MzQgMTYuMjE2MSAxOS45NDk3IDE4Ljk0OTdMMTUgMjMuODk5NUwxMC4wNTAzIDE4Ljk0OTdDNy4zMTY1OCAxNi4yMTYxIDcuMzE2NTggMTEuNzgzOSAxMC4wNTAzIDkuMDUwMjVaTTE1IDE2QzE2LjEwNDYgMTYgMTcgMTUuMTA0NiAxNyAxNEMxNyAxMi44OTU0IDE2LjEwNDYgMTIgMTUgMTJDMTMuODk1NCAxMiAxMyAxMi44OTU0IDEzIDE0QzEzIDE1LjEwNDYgMTMuODk1NCAxNiAxNSAxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=",
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, -35] // ← questo lo sposta in alto
        });

        // Aggiunge i tile di OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            maxZoom: 19,
        }).addTo(map);

        // 4 marker con coordinate approssimative in Molise
        /*
        if (locations == undefined || (Array.isArray(locations) && locations.length === 0)) {
            locations = [
                { lat: 41.5606, lng: 14.6628, label: 'Campobasso' },
                { lat: 41.7071, lng: 14.7785, label: 'Isernia' },
                { lat: 41.7623, lng: 14.3780, label: 'Bojano' },
                { lat: 41.5864, lng: 14.8269, label: 'Termoli' },
            ];
        }
        */
        const bounds = [];
        const markers = [];

        locations.forEach((loc, index) => {
            const number = index + 1;
            const market = L.marker([loc.lat, loc.lng], { icon: customIcon })
                .addTo(map)
                .bindPopup(`<b>${loc.label}</b>`);

            bounds.push([loc.lat, loc.lng]);
            markers.push(market);
        });

        if (bounds.length > 0) {
            map.fitBounds(bounds);
        }


        //Scroll
        const results = document.querySelectorAll('.result-wrapper .card-wrapper');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = Array.from(results).indexOf(entry.target);
                    const marker = markers[index];
                    if (marker) {
                        const latlng = marker.getLatLng();
                        map.flyTo(latlng, 13, { duration: 1.5 });
                        marker.openPopup();
                    }
                }
            });
        }, { threshold: 0.6 });

        results.forEach(section => observer.observe(section));
    }

    window.infobox = (id, target) => {

        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'detail_infobox_callback', // Nome dell'azione registrata in PHP
                id: id
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    target.html("");
                    target.html(response.html);
                }

                /*                 response.data.forEach(element => {
                                    if (element.media_type == "IMAGE" || element.media_type == "CAROUSEL_ALBUM") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption));
                                    }
                                    else if (element.media_type == "VIDEO") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption, 'video'));
                                    }
                                }); */
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }

    window.ospitalita = (id, target, post_type) => {

        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'ospitalita_callback', // Nome dell'azione registrata in PHP
                id: id,
                post_type: post_type
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    target.html("");
                    target.html(response.html);
                }

                /*                 response.data.forEach(element => {
                                    if (element.media_type == "IMAGE" || element.media_type == "CAROUSEL_ALBUM") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption));
                                    }
                                    else if (element.media_type == "VIDEO") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption, 'video'));
                                    }
                                }); */
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }

    window.initShare = (id) => {
        var shareBotton = $('#' + id);
        shareBotton.on('click', (e) => {
            $(e.currentTarget).find('.share-link-wrapper').toggleClass('d-none');
        });
    }


    window.tappe = (id, tappecontainer, mappa) => {

        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'tappe_callback', // Nome dell'azione registrata in PHP
                id: id
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    tappecontainer.html("");
                    tappecontainer.html(response.html);
                    loadMap(mappa, response.marker);
                    cardAppend();
                    loadFavorites();
                }
                /*                 response.data.forEach(element => {
                                    if (element.media_type == "IMAGE" || element.media_type == "CAROUSEL_ALBUM") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption));
                                    }
                                    else if (element.media_type == "VIDEO") {
                                        e.append(instagram_card(element.media_url, element.permalink, element.caption, 'video'));
                                    }
                                }); */
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });

    }

    window.loadMap = (mappa, locations) => {
        // Centra la mappa sul Molise (Campobasso come riferimento)
        const map = L.map(mappa).setView([41.5606, 14.6628], 9);


        // Aggiunge i tile di OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            maxZoom: 19,
        }).addTo(map);

        // 4 marker con coordinate approssimative in Molise
        /*
        const locations = [
            { lat: 41.5606, lng: 14.6628, label: 'Campobasso' },
            { lat: 41.7071, lng: 14.7785, label: 'Isernia' },
            { lat: 41.7623, lng: 14.3780, label: 'Bojano' },
            { lat: 41.5864, lng: 14.8269, label: 'Termoli' },
        ];
        */
        const bounds = [];
        const markers = [];

        locations.forEach((loc, index) => {
            const number = index + 1;
            const customIcon = L.divIcon({
                html: `<div class="tappa-day">${number}</div>`,
                className: "",
                //iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMxRDVFNjgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4wNTAzIDkuMDUwMjVDMTIuNzgzOSA2LjMxNjU4IDE3LjIxNjEgNi4zMTY1OCAxOS45NDk3IDkuMDUwMjVDMjIuNjgzNCAxMS43ODM5IDIyLjY4MzQgMTYuMjE2MSAxOS45NDk3IDE4Ljk0OTdMMTUgMjMuODk5NUwxMC4wNTAzIDE4Ljk0OTdDNy4zMTY1OCAxNi4yMTYxIDcuMzE2NTggMTEuNzgzOSAxMC4wNTAzIDkuMDUwMjVaTTE1IDE2QzE2LjEwNDYgMTYgMTcgMTUuMTA0NiAxNyAxNEMxNyAxMi44OTU0IDE2LjEwNDYgMTIgMTUgMTJDMTMuODk1NCAxMiAxMyAxMi44OTU0IDEzIDE0QzEzIDE1LjEwNDYgMTMuODk1NCAxNiAxNSAxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=",
                iconSize: [30, 30],
                iconAnchor: [15, 30],
                popupAnchor: [0, -35] // ← questo lo sposta in alto
            });
            const market = L.marker([loc.lat, loc.lng], { icon: customIcon })
                .addTo(map)
                .bindPopup(`<b>${loc.label}</b>`);

            bounds.push([loc.lat, loc.lng]);
            markers.push(market);
        });

        if (bounds.length > 0) {
            map.fitBounds(bounds);
        }

        //Scroll
        const tappe = document.querySelectorAll('.tappa-item');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = Array.from(tappe).indexOf(entry.target);
                    const marker = markers[index];
                    if (marker) {
                        const latlng = marker.getLatLng();
                        map.flyTo(latlng, 13, { duration: 1.5 });
                        marker.openPopup();
                    }
                }
            });
        }, { threshold: 0.6 });

        tappe.forEach(section => observer.observe(section));

    }

    window.related = (id, target) => {
        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'related_callback', // Nome dell'azione registrata in PHP
                id: id
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    target.html("");
                    target.html(response.html);
                    cardAppend();
                    loadFavorites();
                }
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }

    window.loadMapInContent = (mappa, loc) => {
        // Centra la mappa sul Molise (Campobasso come riferimento)
        const map = L.map(mappa).setView([41.5606, 14.6628], 9);

        const customIcon = L.icon({
            iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiMxRDVFNjgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4wNTAzIDkuMDUwMjVDMTIuNzgzOSA2LjMxNjU4IDE3LjIxNjEgNi4zMTY1OCAxOS45NDk3IDkuMDUwMjVDMjIuNjgzNCAxMS43ODM5IDIyLjY4MzQgMTYuMjE2MSAxOS45NDk3IDE4Ljk0OTdMMTUgMjMuODk5NUwxMC4wNTAzIDE4Ljk0OTdDNy4zMTY1OCAxNi4yMTYxIDcuMzE2NTggMTEuNzgzOSAxMC4wNTAzIDkuMDUwMjVaTTE1IDE2QzE2LjEwNDYgMTYgMTcgMTUuMTA0NiAxNyAxNEMxNyAxMi44OTU0IDE2LjEwNDYgMTIgMTUgMTJDMTMuODk1NCAxMiAxMyAxMi44OTU0IDEzIDE0QzEzIDE1LjEwNDYgMTMuODk1NCAxNiAxNSAxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=",
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, -35] // ← questo lo sposta in alto
        });

        // Aggiunge i tile di OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            maxZoom: 19,
        }).addTo(map);

        const bounds = [];
        const market = L.marker([loc.lat, loc.lng], { icon: customIcon })
            .addTo(map)
            .bindPopup(`<b>${loc.label}</b>`);

        bounds.push([loc.lat, loc.lng]);

        if (bounds.length > 0) {
            map.fitBounds(bounds);
        }
    }

    window.scopri = (id, post_type, target) => {
        const favorites = localStorage.getItem('favorites');
        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'scopri_callback', // Nome dell'azione registrata in PHP
                post_type: post_type,
                id: id
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    if (post_type != 'lasciati-ispirare' || (!favorites || favorites === '[]')) {
                        target.html("");
                        target.html(response.html);
                        cardAppend();
                        loadFavorites();
                    }
                    else {
                        target.remove();
                    }
                    0
                }
                else {
                    target.remove();
                }
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }


    window.download_pdf =  (target) => {
        const download = document.getElementById(target);
        download.addEventListener('click', function (e) {
            console.log("Download");
            salvaPDF();
        })
        let favorites = localStorage.getItem('favorites');
        let favoritesDates = localStorage.getItem('favoritesDates');
        if ((!favorites || favorites === '[]')) {
            $('#' + target).remove()
        }

    }

    async function salvaPDF() {
        const elemento = $("main")[0];
        const clone = elemento.cloneNode(true);

        const elementiDaEscludere = clone.querySelectorAll(".no-print");
        elementiDaEscludere.forEach(el => el.remove());

        // **Qui inserisci gli spacer ogni 7 elementi**
        const cards = clone.querySelectorAll('.card-mio-viaggio');
        for (let i = 6, gruppoIndex = 1; i < cards.length; i += 7, gruppoIndex++) {
            const spacer = document.createElement('div');
            spacer.className = 'page-break-spacer';

            // Altezza di default 100px
            let altezzaSpazio = 200;

            // Personalizza altezza in base all'indice gruppo (esempio)
            const altezzePersonalizzate = {
                1: 150,  // per il primo break
                2: 200,  // per il secondo break
                // puoi aggiungere altri indici qui
            };

            if (altezzePersonalizzate[gruppoIndex]) {
                altezzaSpazio = altezzePersonalizzate[gruppoIndex];
            }

            spacer.style.height = altezzaSpazio + 'px';
            spacer.style.width = '100%';

            cards[i].after(spacer);
        }

        const container = document.createElement('div');
        container.style.position = 'fixed';
        container.style.left = '-9999px';
        container.style.top = '0';
        document.body.appendChild(container);
        container.appendChild(clone);

        const canvas = await html2canvas(clone, { useCORS: true, scale: 2 });

        document.body.removeChild(container);

        const imgData = canvas.toDataURL('image/jpeg',0.6);

        const pdf = new jsPDF('p', 'pt', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save('il-mio-viaggio.pdf');
    }    

    window.share_mio_viaggio = (target, id) => {
        let favorites = localStorage.getItem('favorites');
        let favoritesDates = localStorage.getItem('favoritesDates');

        $.ajax({
            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
            type: 'POST', // Tipo di richiesta
            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
            data: {
                action: 'share_callback', // Nome dell'azione registrata in PHP
                favorites: favorites,
                favoritesDates: favoritesDates,
                id: id
            },
            success: function (response) {
                // Gestione della risposta in caso di successo
                if (response.html) {
                    target.html("");
                    target.removeAttr('style');
                    target.html(response.html);
                }
                else {
                    target.remove();
                }
            },
            error: function (xhr, status, error) {
                // Gestione degli errori
                console.error('Errore nella richiesta:', error);
            }
        });
    }

    window.login = (nonce, target, modalID) => {
        const modal = document.querySelector(modalID);
        const form = document.querySelector(target);

        if (form) {
            const login = form.querySelector("[href='#login']");
            login.addEventListener('click', function (event) {
                if (form.reportValidity()) {
                    modal.classList.remove('fade');
                    modal.classList.remove('d-none');
                    const user = form.querySelector('[name=log]').value;
                    const pwd = form.querySelector('[name=pwd]').value;

                    $.ajax(
                        {
                            url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
                            type: 'POST', // Tipo di richiesta
                            dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
                            data: {
                                action: 'login_callback', // Nome dell'azione registrata in PHP
                                user: user,
                                pwd: pwd,
                                security: nonce

                            },
                            success: function (response) {
                                modal.classList.add('fade');
                                modal.classList.add('d-none');
                                if (response.success) {
                                    window.location.href = response.redirect;

                                }
                                else {
                                    form.querySelector('#login-message').innerHTML = response.message;
                                }
                            },
                            error: function (xhr, status, error) {
                                // Gestione degli errori
                                console.error('Errore nella richiesta:', error);
                            }
                        }
                    );
                }
            });
        }

        const logout = document.querySelector("[href='#logout']");
        if (logout) {
            logout.addEventListener('click', function (event) {
                modal.classList.remove('fade');
                modal.classList.remove('d-none');
                $.ajax(
                    {
                        url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
                        type: 'POST', // Tipo di richiesta
                        dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
                        data: {
                            action: 'logout_callback', // Nome dell'azione registrata in PHP
                            security: nonce

                        },
                        success: function (response) {
                            modal.classList.add('fade');
                            modal.classList.add('d-none');
                            if (response.success) {
                                window.location.href = response.redirect;

                            }
                        },
                        error: function (xhr, status, error) {
                            // Gestione degli errori
                            console.error('Errore nella richiesta:', error);
                        }
                    }
                );
            })
        }
    }

    window.come_arrivare = () => {

        const buttons = document.querySelectorAll('.buttons-scroll a');
        const come_arrivare = document.querySelectorAll('.come-arrivare-block');

        buttons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                come_arrivare.forEach(e => e.classList.add('d-none'));
                const hash = (new URL(this.href)).hash;
                document.querySelector(hash).classList.remove('d-none');
            });
        });

    }

    window.registrati = (nonce, formId,modalID) => {
        const form = document.querySelector(formId);
        const fileInputs = form.querySelectorAll('input[type="file"]');
        fileInputs.forEach(e => {
            const fileInput = document.querySelector('#btn-' + e.id);
            const fileNameDisplay = document.getElementById('fileName-' + e.id);
            fileInput.addEventListener('click', function (event) {
                document.getElementById(e.id).click();
            });
            e.addEventListener('change', function () {
                if (this.files.length > 0) {
                    const names = Array.from(this.files).map(f => f.name).join(', ');
                    fileNameDisplay.textContent = names;
                } else {
                    fileNameDisplay.textContent = 'Nessun file selezionato';
                }
            });

        });
        window.registrati_validator = new JustValidate(formId);
        registrati_validator
            .onSuccess(() => {
                const modal = document.querySelector(modalID);
                const title = modal.querySelector('h5');
                const spin = modal.querySelector('.spinner-border'); 
                const form2 = document.querySelector(formId);
                const formData = new FormData(form2); // Contiene tutti i campi, incluso file
                formData.append('action', 'registrati_callback');
                formData.append('security', nonce);
                modal.classList.remove('fade');
                modal.classList.remove('d-none');                
                $.ajax(
                    {
                        url: '/wp-admin/admin-ajax.php', // L'indirizzo a cui inviare la richiesta
                        type: 'POST', // Tipo di richiesta
                        dataType: 'json', // Tipo di dato che ci si aspetta di ricevere (opzionale)
                        data: formData,
                        contentType: false, // Important!
                        processData: false, // Important!
                        success: function (response) {
                            modal.querySelector('#registerMessage').innerHTML=response.message;
                            modal.querySelector('[href="#exit"]').parentElement.classList.remove('d-none');
                            modal.querySelector('[href="#exit"]').parentElement.addEventListener('click', function (event) {
                                 window.location.href = response.redirect;
                            });
                            title.classList.add('d-none');
                            spin.classList.add('d-none');
                        },
                        error: function (xhr, status, error) {
                            // Gestione degli errori
                            console.error('Errore nella richiesta:', error);
                        }
                    })
            })
            .onFail(() => {
                console.log('ciao fail');
            })

    }

})(window.jQuery); 